import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import { GET_TARGET } from './type';

export const getTargetDataSequence = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.targetData}?site_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: GET_TARGET, payload: data.response.data });
    return data.response.data;
  }
};

export const postTargetData = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.installation.postTargetData
  );
  if (res) {
    return true;
  }
};

export const postVerifyData = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.installation.postVerifyData
  );
  
  if (res?.data?.status == true) {
    console.log(res);
    return true;
  }
};

